import * as React from "react";
import { render } from "react-dom";
import { ReduxRoot } from "./core";

const rootEl = document.getElementById("root");

render(<ReduxRoot />, rootEl);
